export default {
  filtros: 'Filtros',
  formulario_invalido:
    'É necessário preencher o formulário antes de salvar o registro.',
  orcamento_salvo_sucesso: 'Orçamento Aprovado com Sucesso',
  orcamento_reprovado_sucesso: 'Orçamento Reprovado com Sucesso',
};
